<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        {{ empresa.nombrec }}
        <small class="title is-5"
          >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
        >
        <small class="subtitle is-7">{{ empresa.nombre }}</small>
      </h1>
      <y-periodselector
        @period="periodselected"
        :iscierre="true"
        :period="period"
      ></y-periodselector>
      <div class="columns">
        <div class="column">
          <div class="field is-fullwidth has-addons">
            <div class="control">
              <a class="button is-light" @click="launchModal">
                <span class="icon">
                  <i class="material-icons">list_alt</i>
                </span>
              </a>
            </div>
            <div class="control is-expanded has-icons-left">
              <input
                id="c1"
                @blur="blurFunction('c1')"
                @keydown="keyfunction($event, 'c1')"
                class="input is-fullwidth"
                type="text"
                v-model="textInputs.c1"
                placeholder="Comprobante"
                autocomplete="off"
              />
              <span v-show="editsel" class="icon is-small is-left">
                <i class="material-icons">edit</i>
              </span>
              <span v-show="!editsel" class="icon is-small is-left">
                <i class="material-icons">control_camera</i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <fieldset>
            <div class="field">
              <div class="control">
                <input
                  id="c2"
                  @blur="blurFunction('c2')"
                  @keydown="keyfunction($event, 'c2')"
                  class="input"
                  v-model="textInputs.c2"
                  type="text"
                  placeholder="Documento"
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div class="column">
          <div class="field is-fullwidth has-addons">
            <p class="control is-expanded">
              <input
                class="input"
                id="c3"
                @blur="blurFunction('c3')"
                @keydown="keyfunction($event, 'c3')"
                type="number"
                placeholder="Fecha"
                v-model="textInputs.c3"
              />
            </p>
            <p class="control">
              <a class="button is-static">{{
                comundata.periodo ? comundata.periodo : "xx" | periodo()
              }}</a>
            </p>
          </div>
        </div>
      </div>
      <div v-show="existborrador" class="columns">
        <div class="column">
          <div class="notification is-link">
            <h1 class="title">Existe un borrador</h1>
            <h1 class="subtitle">
              Existe un borrador que no ha sido guardado, ¿desea cargarlo?
            </h1>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="cargarborrador"
            >
              Si
            </button>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="(existborrador = false), (borrador = null)"
            >
              No
            </button>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="eliminarborrador"
            >
              Eliminar borrador
            </button>
          </div>
        </div>
      </div>
      <div v-if="!comundata.comprobante" class="columns">
        <div class="column">
          <div class="notification">
            <h1 class="title">yungol es ágil y fácil de usar.</h1>
            <h2 class="subtitle">
              <br />Te recomendamos utilizar estos atajos para navegar más
              rápido en nuestro sistema.
            </h2>
            <div class="content">
              <ul>
                <li>
                  <strong>F3</strong> Con esta tecla puedes desplegar el menú
                  con las opciones. O puedes dar clic directamente en este icono
                  <span class="icon">
                    <i class="material-icons icon-lista">list_alt</i>
                  </span>
                </li>
                <li>
                  <strong>F2</strong> Con esta tecla puedes editar los textos en
                  la celda actual.
                </li>
                <li>
                  <span class="icon">
                    <i class="material-icons">keyboard_return</i>
                  </span>
                  Con enter puedes desplazarte rápidamente hacia la columna
                  siguiente, también puedes hacerlo con las flechas del teclado.
                </li>
                <li>
                  <strong>F10</strong>
                  Con esta tecla puedes guardar rápidamenten el documento.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="comundata.comprobante" class="columns">
        <div class="column">
          <div
            class="notification"
            v-for="(rg, index) in registros"
            :key="index"
          >
            <y-viewregistro
              :index="index"
              :fila="fila"
              :columna="columna"
              :reg="rg"
              :selection="selection"
              :selcolumn="selcolumn"
              @fila="changeFila"
              @columna="changeColumna"
            ></y-viewregistro>
            <y-formregistro
              v-if="showInput(index)"
              :index="index"
              :fila="fila"
              :reg="registros"
              :columna="columna"
              :selection="selection"
              :selcolumn="selcolumn"
              :lengthReg="registros.length"
              :comundata="comundata"
              :cuentasModal="cuentasModal"
              @deleteReg="deleteReg"
              @validaReg="validaRegistro"
              @newReg="addReg"
              @fila="changeFila"
              @columna="changeColumna"
              @changeInputReg="changeData"
              @f10guardar="f10guardar"
            ></y-formregistro>
          </div>
          <div class="columns">
            <div class="column">
              <div class="notification">
                <strong>Resumen</strong>
                <table class="fontMono" style="width: 100%">
                  <thead>
                    <tr>
                      <th style="width: 50%" class="bordebutton"></th>
                      <th class="has-text-right bordebutton">Debito</th>
                      <th class="has-text-right bordebutton">Credito</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sgrupo, index) in totales.list" :key="index">
                      <td class="bordebutton">{{ sgrupo }}</td>
                      <td class="has-text-right bordebutton">
                        {{ totales[sgrupo].debito | number(2) }}
                      </td>
                      <td class="has-text-right bordebutton">
                        {{ totales[sgrupo].credito | number(2) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td class="has-text-right">
                        <strong>{{ totales.total.debito | number(2) }}</strong>
                      </td>
                      <td class="has-text-right">
                        <strong>{{ totales.total.credito | number(2) }}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td class="has-text-right has-text-grey-light">
                        <small>{{
                          totales.diferencia.debito | number(2)
                        }}</small>
                      </td>
                      <td class="has-text-right has-text-grey-light">
                        <small>{{
                          totales.diferencia.credito | number(2)
                        }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="column">
              <div class="buttons">
                <button
                  class="button is-primary is-medium"
                  id="botonGuardar"
                  @click="f10guardar"
                >
                  <span class="icon is-medium">
                    <i class="material-icons">save</i> </span
                  >&nbsp; Guardar F10
                </button>
                <!-- <button
                  class="button is-light is-medium"
                  v-show="!turno._id"
                  @click="saveandprint"
                >
                  <span class="icon is-medium">
                    <i class="material-icons">print</i> </span
                  >&nbsp; Guardar e Imprimir
                </button> -->
                <button class="button is-warning is-medium" @click="cancelar">
                  <span class="icon is-medium">
                    <i class="material-icons">cancel</i> </span
                  >&nbsp; Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import functions from "@/helpers/functions";
import apiServices from "@/services/yungol-services";
import yFormregistro from "@/components/registrar/Formregistro2.vue";
import yViewregistro from "@/components/registrar/Viewregistro2.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      youcansave: true,
      totales: {
        list: [],
        total: {
          debito: 0,
          credito: 0,
        },
        diferencia: {
          debito: 0,
          credito: 0,
        },
      },
      registros: [],
      cuentasModal: [],
      fila: 0,
      columna: 1,
      existborrador: false,
      period: {
        year: null,
        months: null,
      },
      comprobanteModal: [],
      textInputs: {
        c1: "",
        c2: null,
        c3: null,
      },
      editsel: false,
      comundata: {
        comprobante: null,
        numDoc: null,
        dia: null,
        periodo: null,
        ccostos: null,
      },
      selcolumn: {
        columnValor: 0,
        columnBase: 0,
        columnccostos: 0,
        columndocRef: 0,
        columndescripcion: 0,
        columnnit: 0,
        columncuenta: 0,
        columntipo: 0,
        columnproducto: 0,
        columncantidad: 0,
        columnpunitario: 0,
        columnbodega: 0,
        columncodbatch: 0,
        columnnombatch: 0,
      },
      selection: [
        {
          cod: "cuenta",
          nombre: "Cuenta",
          bd: "idcuenta",
          tiene: "tCuenta",
          valida: "cumpleCuenta",
          texto: "nombreCuenta",
        },
        {
          cod: "nit",
          nombre: "Nit",
          bd: "idnit",
          tiene: "tNit",
          valida: "cumpleNit",
          texto: "nombreNit",
        },
        {
          cod: "nproducto",
          nombre: "Producto",
          bd: "producto",
          tiene: "tProducto",
          valida: "cumpleProducto",
          texto: "nombreproducto",
        },
        {
          cod: "nbodega",
          nombre: "Bodega",
          bd: "bodega",
          tiene: "tBodega",
          valida: "cumpleBodega",
          texto: "nombrebodega",
        },
        {
          cod: "cantidad",
          nombre: "Cantidad",
          bd: "cantidad",
          tiene: "tCantidad",
          valida: "cumpleCantidad",
          texto: "cantidad",
        },
        {
          cod: "vlrUnitario",
          nombre: "P Unit",
          bd: "vlrUnitario",
          tiene: "tPreciounitario",
          valida: "cumplePreciounitario",
          texto: "vlrUnitario",
        },
        {
          cod: "descripcion",
          nombre: "Descripción",
          bd: "descripcion",
          tiene: "tDescripcion",
          valida: "cumpleDescripcion",
          texto: "descripcion",
        },
        {
          cod: "docRef",
          nombre: "Referencia",
          bd: "docRef",
          tiene: "tDocref",
          valida: "cumpleRef",
          texto: "docRef",
        },
        {
          cod: "ccostos",
          nombre: "C Costos",
          bd: "ccostos",
          tiene: "tCcosto",
          valida: "cumpleCcosto",
          texto: "nombreCcostos",
        },
        {
          cod: "base",
          nombre: "Base",
          bd: "base",
          tiene: "tBase",
          valida: "cumpleBase",
          texto: "base",
        },
        {
          cod: "tipo",
          nombre: "T",
          bd: "tipo",
          tiene: "tTipo",
          valida: "cumpleTipo",
          texto: "tipo",
        },
        {
          cod: "valor",
          nombre: "Valor",
          bd: "valor",
          tiene: "tValor",
          valida: "cumpleValor",
          texto: "valor",
        },
      ],
    };
  },
  computed: {
    ...mapState([
      "empresa",
      "resultDatamodal",
      "nits",
      "cuentas",
      "productos",
      "bodegas",
    ]),
  },
  methods: {
    cancelar() {
      let temporal = localStorage.getItem("temporalcontador");
      temporal = JSON.parse(temporal);
      if (temporal) {
        this.existborrador = true;
        this.borrador = temporal;
      } else {
        this.existborrador = false;
        this.borrador = null;
      }
      this.guardando = false;
      this.registros = [];
      this.traeComprobantes(this);
      this.textInputs.c1 = "";
      this.textInputs.c2 = null;
      this.textInputs.c3 = null;
      this.comundata.comprobante = null;
      this.comundata.numDoc = null;
      this.comundata.dia = null;
      this.comundata.periodo = null;
      this.totales.list = [];
      this.totales.total.debito = 0;
      this.totales.total.credito = 0;
      this.totales.diferencia.debito = 0;
      this.totales.diferencia.credito = 0;
      document.getElementById("c1").focus();
    },
    addReg() {
      this.createreg(this, false);
    },
    validaCuenta(fila, _this) {
      const data = functions.findData(
        this.cuentas,
        this.registros[fila].cuenta,
        "codigo"
      );
      if (data) {
        _this.registros[fila].cuentadetalle = data;
        _this.registros[fila].cumpleCuenta = true;
        _this.registros[fila].cumpleNit = true;
        _this.registros[fila].cumpleDescripcion = true;
        _this.registros[fila].cumpleRef = true;
        _this.registros[fila].cumpleCcosto = true;
        _this.registros[fila].cumpleBase = true;
        _this.registros[fila].cumpleProducto = true;
        _this.registros[fila].cumpleBatchcodigo = true;
        _this.registros[fila].cumpleBatchnombre = true;
        _this.registros[fila].cumpleCantidad = true;
        _this.registros[fila].cumplePreciounitario = true;
        _this.registros[fila].cumpleBodega = true;
        _this.registros[fila].cumpleValor = true;
        _this.registros[fila].cumpleTipo = true;
        _this.registros[fila].cumpleTodo = false;
        _this.registros[fila].porcentaje = null;
        _this.registros[fila].tCuenta = true;
        _this.registros[fila].tNit = false;
        _this.registros[fila].tDescripcion = true;
        _this.registros[fila].tCcosto = false;
        _this.registros[fila].tBase = false;
        _this.registros[fila].tDocref = false;
        _this.registros[fila].tProducto = false;
        _this.registros[fila].tProducto = false;
        _this.registros[fila].tBatchcodigo = false;
        _this.registros[fila].tBatchnombre = false;
        _this.registros[fila].tPreciounitario = false;
        _this.registros[fila].tBodega = false;
        _this.registros[fila].tTipo = true;
        _this.registros[fila].tValor = true;
        _this.registros[fila].turno = null;
        _this.registros[fila].tipor = null;
        _this.registros[fila][this.selection[0].texto] = null;
        _this.registros[fila][this.selection[0].bd] = null;
        _this.registros[fila][this.selection[0].texto] = data.nombre;
        _this.registros[fila][this.selection[0].bd] = data._id;
        if (data.base) {
          _this.registros[fila].porcentaje = data.porcentaje;
          _this.registros[fila].tBase = true;
        } else {
          _this.registros[fila].porcentaje = null;
          _this.registros[fila].tBase = false;
        }
        if (data.ccosto) {
          _this.registros[fila].tCcosto = true;
        } else {
          _this.registros[fila].tCcosto = false;
        }
        if (data.dctoref) {
          _this.registros[fila].tDocref = true;
        } else {
          _this.registros[fila].tDocref = false;
        }
        if (data.tercero) {
          _this.registros[fila].tNit = true;
        } else {
          _this.registros[fila].tNit = false;
        }
        if (data.producto) {
          _this.registros[fila].tProducto = true;
          if (_this.empresa.lote) {
            _this.registros[fila].tBatchcodigo = true;
            _this.registros[fila].tBatchnombre = true;
          }
          _this.registros[fila].tCantidad = true;
          _this.registros[fila].tPreciounitario = true;
          _this.registros[fila].tBodega = true;
          if (data.inventario) {
            _this.registros[fila].tipor = "inventario";
          }
          if (data.costoProd) {
            _this.registros[fila].tipor = "costo";
          }
          if (data.ingreso) {
            _this.registros[fila].tipor = "ingreso";
          }
        }
      } else {
        _this.registros[fila].porcentaje = null;
        _this.registros[fila][this.selection[0].texto] = null;
        _this.registros[fila][this.selection[0].bd] = null;
        // _this.registros[fila].tBase = false; // no se debería borrar esto con poner que no cumple cuenta es suficiente
        // _this.registros[fila].tCcosto = false;
        // _this.registros[fila].tDocref = false;
        // _this.registros[fila].tNit = false;
        _this.registros[fila].cumpleCuenta = false;
      }
    },
    validaconcepto(fila, colValidar, _this) {
      // en data._id, debe ir lo que se va a guardar en base de datos por eso en descripcion y ccostos se cambia el id por el texto o el codigo
      let data = null;
      if (colValidar === this.selcolumn.columnnit) {
        data = functions.findData(
          _this.nits,
          _this.registros[fila].nit,
          "codigo"
        );
      }
      if (colValidar === this.selcolumn.columndescripcion) {
        if (_this.registros[fila].descripcion) {
          data = {};
          data.nombre = _this.registros[fila].descripcion;
          data._id = _this.registros[fila].descripcion;
        }
      }
      if (colValidar === this.selcolumn.columncodbatch) {
        if (_this.registros[fila].batchcodigo) {
          data = {};
          data.nombre = _this.registros[fila].batchcodigo;
          data._id = _this.registros[fila].batchcodigo;

          let data1 = null;
          let datalote = [];
          if (
            _this.registros[fila].productodetalle &&
            _this.registros[fila].productodetalle.lote &&
            _this.registros[fila].productodetalle.lote[
              _this.registros[fila].bodega
            ]
          ) {
            datalote = _this.registros[fila].productodetalle.lote[
              _this.registros[fila].bodega
            ].list.map((e) => {
              const d = {
                codigo: e,
                nombre: `${
                  _this.registros[fila].productodetalle.lote[
                    _this.registros[fila].bodega
                  ][e].nombre
                }`,
                id: e,
                selected: false,
              };
              return d;
            });
          }
          data1 = functions.findData(
            datalote,
            _this.registros[fila].batchcodigo,
            "codigo"
          );
          if (data1) {
            _this.registros[fila].batchnombre = data1.nombre;
          }
        }
      }
      if (colValidar === this.selcolumn.columnnombatch) {
        if (_this.registros[fila].batchnombre) {
          data = {};
          data.nombre = _this.registros[fila].batchnombre;
          data._id = _this.registros[fila].batchnombre;
        }
      }
      if (colValidar === this.selcolumn.columndocRef) {
        data = {};
        data.nombre = _this.registros[fila].docRef;
        data._id = _this.registros[fila].docRef;
      }
      if (colValidar === this.selcolumn.columnccostos) {
        data = functions.findData(
          _this.comundata.ccostos,
          _this.registros[fila].ccostos,
          "codigo"
        );
        if (data) {
          data._id = data.codigo;
        }
      }
      if (colValidar === this.selcolumn.columnBase) {
        _this.registros[fila].base = parseFloat(_this.registros[fila].base);
        if (_this.registros[fila].base) {
          if (isNaN(_this.registros[fila].base)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].base = null;
          } else {
            if (_this.registros[fila].base === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].base = null;
            } else {
              data = {};
              data.nombre = _this.registros[fila].base;
              data._id = _this.registros[fila].base;
            }
          }
        }
      }
      if (colValidar === this.selcolumn.columnValor) {
        if (_this.registros[fila].valor === null) {
          _this.registros[fila].valor = 0;
        }
        _this.registros[fila].valor =
          Math.round(_this.registros[fila].valor * 100) / 100;
        if (_this.registros[fila].valor) {
          if (isNaN(_this.registros[fila].valor)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].valor = 0;
          } else {
            if (_this.registros[fila].valor === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].valor = 0;
            } else if (_this.registros[fila].valor < 0) {
              _this.registros[fila].valor =
                (Math.round(_this.registros[fila].valor * 100) / 100) * -1;
              data = {};
              data.nombre = _this.registros[fila].valor;
              data._id = _this.registros[fila].valor;
            } else {
              data = {};
              data.nombre = _this.registros[fila].valor;
              data._id = _this.registros[fila].valor;
            }
          }
        }
      }
      if (colValidar === this.selcolumn.columntipo) {
        if (_this.registros[fila].tipo) {
          data = {};
          if (_this.registros[fila].tipo === "1") {
            data.nombre = "1";
            data._id = "1";
          } else {
            data.nombre = "2";
            data._id = "2";
          }
        }
      }
      if (colValidar === this.selcolumn.columnproducto) {
        data = functions.findData(
          _this.productos,
          _this.registros[fila].nproducto,
          "codigo"
        );
        if (data) {
          data.nombre = data.descripcion;
          _this.registros[fila].productodetalle = data;
          if (_this.registros[fila].cuentadetalle) {
            let idcuentacomparar;
            if (_this.registros[fila].cuentadetalle.inventario) {
              idcuentacomparar = data.linea.ctaInventario;
            }
            if (_this.registros[fila].cuentadetalle.ingreso) {
              idcuentacomparar = data.linea.ctaIngreso;
            }
            if (_this.registros[fila].cuentadetalle.costoProd) {
              idcuentacomparar = data.linea.ctaCosto;
            }
            _this.cuentas.forEach(function (k, v) {
              if (k._id === idcuentacomparar) {
                _this.registros[fila].cuenta = k.codigo;
              }
            });
            _this.validaCuenta(fila, _this);
          }
        }
      }
      if (colValidar === this.selcolumn.columncantidad) {
        if (_this.registros[fila].cantidad === null) {
          _this.registros[fila].cantidad = 0;
        }
        _this.registros[fila].cantidad = parseFloat(
          _this.registros[fila].cantidad
        );
        if (_this.registros[fila].cantidad) {
          if (isNaN(_this.registros[fila].cantidad)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].cantidad = 0;
          } else {
            if (_this.registros[fila].cantidad === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].cantidad = 0;
            } else if (_this.registros[fila].cantidad < 0) {
              _this.registros[fila].cantidad =
                _this.registros[fila].cantidad * -1;
              data = {};
              data.nombre = _this.registros[fila].cantidad;
              data._id = _this.registros[fila].cantidad;
            } else {
              data = {};
              data.nombre = _this.registros[fila].cantidad;
              data._id = _this.registros[fila].cantidad;
            }
          }
        }
      }
      if (colValidar === this.selcolumn.columnpunitario) {
        if (_this.registros[fila].vlrUnitario === null) {
          _this.registros[fila].vlrUnitario = 0;
        }
        _this.registros[fila].vlrUnitario = parseFloat(
          _this.registros[fila].vlrUnitario
        );
        if (_this.registros[fila].vlrUnitario) {
          if (isNaN(_this.registros[fila].vlrUnitario)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].vlrUnitario = 0;
          } else {
            if (_this.registros[fila].vlrUnitario === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].vlrUnitario = 0;
            } else if (_this.registros[fila].vlrUnitario < 0) {
              _this.registros[fila].vlrUnitario =
                _this.registros[fila].vlrUnitario * -1;
              data = {};
              data.nombre = _this.registros[fila].vlrUnitario;
              data._id = _this.registros[fila].vlrUnitario;
            } else {
              data = {};
              data.nombre = _this.registros[fila].vlrUnitario;
              data._id = _this.registros[fila].vlrUnitario;
            }
          }
          if (_this.registros[fila][_this.selection[colValidar - 1].tiene]) {
            _this.registros[fila].valor =
              _this.registros[fila].vlrUnitario *
              _this.registros[fila].cantidad;
          }
        }
      }
      if (colValidar === this.selcolumn.columnbodega) {
        data = functions.findData(
          _this.bodegas,
          _this.registros[fila].nbodega,
          "codigo"
        );
        if (data) {
          data.nombre = data.descripcion;
          if (
            _this.registros[fila].productodetalle &&
            _this.registros[fila].productodetalle.datosProducto &&
            _this.registros[fila].productodetalle.datosProducto[data._id]
          ) {
            if (_this.registros[fila].vlrUnitario === 0) {
              _this.registros[fila].vlrUnitario =
                _this.registros[fila].productodetalle.datosProducto[
                  data._id
                ].ultimoCalculo.costo;
            }
          }
        }
      }
      if (_this.registros[fila][_this.selection[colValidar - 1].tiene]) {
        if (data) {
          _this.registros[fila][_this.selection[colValidar - 1].texto] =
            data.nombre;
          _this.registros[fila][_this.selection[colValidar - 1].bd] = data._id;
          _this.registros[fila][_this.selection[colValidar - 1].valida] = true;
        } else {
          _this.registros[fila][this.selection[colValidar - 1].texto] = null;
          _this.registros[fila][this.selection[colValidar - 1].bd] = null;
          _this.registros[fila][_this.selection[colValidar - 1].valida] = false;
        }
      } else {
        _this.registros[fila][this.selection[colValidar - 1].texto] = null;
        _this.registros[fila][this.selection[colValidar - 1].bd] = null;
        _this.registros[fila][_this.selection[colValidar - 1].valida] = true;
      }
    },
    validaRenglon(fila) {
      this.validaCuenta(fila, this);
      const _this = this;
      this.selection.forEach(function (k, v) {
        if (v > 0) {
          _this.validaconcepto(fila, v + 1, _this);
        }
      });
      if (
        this.registros[fila].cumpleCuenta &&
        this.registros[fila].cumpleNit &&
        this.registros[fila].cumpleDescripcion &&
        this.registros[fila].cumpleRef &&
        this.registros[fila].cumpleCcosto &&
        this.registros[fila].cumpleBase &&
        this.registros[fila].cumpleProducto &&
        this.registros[fila].cumpleCantidad &&
        this.registros[fila].cumplePreciounitario &&
        this.registros[fila].cumpleBodega &&
        this.registros[fila].cumpleTipo &&
        this.registros[fila].cumpleValor
      ) {
        this.registros[fila].mes = functions.mes(this.comundata.periodo);
        this.registros[fila].year = functions.year(this.comundata.periodo);

        this.registros[fila].fecha = new Date(
          functions.year(this.comundata.periodo),
          this.registros[fila].mes - 1,
          this.comundata.dia
        );
        this.registros[fila].comprobanteid = this.comundata.comprobante._id;
        this.registros[fila].grupo = functions.grupo(
          this.registros[fila].cuenta
        );
        this.registros[fila].sgrupo = functions.sgrupo(
          this.registros[fila].cuenta
        );
        this.registros[fila].scuenta = functions.scuenta(
          this.registros[fila].cuenta
        );
        if (!this.registros[fila].tBase) {
          this.registros[fila].base = 0;
        }
        if (!this.registros[fila].tDocref) {
          this.registros[fila].docRef = "0";
        }
        if (!this.registros[fila].tCcosto) {
          this.registros[fila].ccostos = "0";
        }
        if (!this.registros[fila].tNit) {
          this.registros[fila].idnit = this.empresa.nit0;
        }
        this.registros[fila].documento = this.textInputs.c2;
        this.registros[fila].orden = fila;
        this.registros[fila].cumpleTodo = true;
      } else {
        this.registros[fila].cumpleTodo = false;
      }
    },
    validaRegistro() {
      this.validaRenglon(this.fila);
    },
    changeFila(n) {
      this.fila = n;
    },
    f10guardar() {
      if (this.youcansave) {
        this.youcansave = false;
        const _this = this;
        let cumpletodo = true;
        if (this.registros.length > 1) {
          for (let index in this.registros) {
            if (_this.registros[index].valor > 0) {
              _this.validaRenglon(index);
              if (!_this.registros[index].cumpleTodo) {
                cumpletodo = false;
              }
            } else {
              _this.registros.splice(index, 1);
            }
          }
          if (!cumpletodo) {
            this.youcansave = true;
            this.$store.dispatch("notify", {
              message:
                "No se pueden guardar los registros. Debe corregir los campos en color rojo",
              type: "is-danger",
              position: "top-center",
            });
            return false;
          } else {
            this.calculaTotales();
            const diferencia =
              Math.round(this.totales.total.debito * 100) -
              Math.round(this.totales.total.credito * 100);
            if (diferencia === 0) {
              this.guardaRegistros();
            } else {
              this.youcansave = true;
              this.$store.dispatch("notify", {
                message: "Los Debitos y creditos deben ser iguales.",
                type: "is-warning",
                position: "top-center",
              });
            }
          }
        } else {
          this.youcansave = true;
          this.$store.dispatch("notify", {
            message: "Debe tener una contrapartida.",
            type: "is-warning",
            position: "top-center",
          });
        }
      }
    },
    saveRecors(registros) {
      return new Promise(async function (resolve, reject) {
        try {
          const result = await apiServices.post(
            `/registroslotecontador`,
            registros
          );
          return resolve(result);
        } catch (err) {
          return reject(err);
        }
      });
    },
    async guardaRegistros() {
      const _this = this;
      let result;
      try {
        result = await this.saveRecors(_this.registros);
        if (result.data) {
          this.registros = [];
          localStorage.removeItem("temporalcontador");
          this.existborrador = false;
          this.borrador = null;
          this.traeComprobantes(this);
          this.textInputs.c1 = "";
          this.textInputs.c2 = null;
          this.textInputs.c3 = null;
          this.comundata.comprobante = null;
          this.comundata.numDoc = null;
          this.comundata.dia = null;
          this.comundata.periodo = null;
          this.totales.list = [];
          this.totales.total.debito = 0;
          this.totales.total.credito = 0;
          this.totales.diferencia.debito = 0;
          this.totales.diferencia.credito = 0;
          document.getElementById("c1").focus();
          this.youcansave = true;
          this.$store.dispatch("notify", {
            message: "Registro guardado con éxito.",
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        this.youcansave = true;
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando los registros", err);
      }
    },
    calculaTotales() {
      const _this = this;
      this.totales = {
        list: [],
        total: {
          debito: 0,
          credito: 0,
        },
        diferencia: {
          debito: 0,
          credito: 0,
        },
      };
      for (let index in this.registros) {
        const registro = this.registros[index];
        if (registro.cuenta) {
          if (
            _this.totales.list.indexOf(functions.sgrupo(registro.cuenta)) === -1
          ) {
            _this.totales.list.push(functions.sgrupo(registro.cuenta));
            _this.totales[functions.sgrupo(registro.cuenta)] = {
              debito: 0,
              credito: 0,
            };
          }
          if (parseInt(registro.tipo) === 1) {
            _this.totales[
              functions.sgrupo(registro.cuenta)
            ].debito += Math.round(registro.valor * 100);
            _this.totales.total.debito += Math.round(registro.valor * 100);
          } else {
            _this.totales[
              functions.sgrupo(registro.cuenta)
            ].credito += Math.round(registro.valor * 100);
            _this.totales.total.credito += Math.round(registro.valor * 100);
          }
        }
      }
      _this.totales.list.sort();
      for (let index in _this.totales.list) {
        const tot = _this.totales.list[index];
        _this.totales[tot].debito = _this.totales[tot].debito / 100;
        _this.totales[tot].credito = _this.totales[tot].credito / 100;
      }
      this.totales.total.debito = this.totales.total.debito / 100;
      this.totales.total.credito = this.totales.total.credito / 100;

      let diferencia = this.totales.total.debito - this.totales.total.credito;
      if (diferencia > 0) {
        this.totales.diferencia.credito = diferencia;
      } else {
        this.totales.diferencia.debito = -diferencia;
      }
    },
    changeData(payload) {
      // si esta en la columna total no puede editar la cuenta ni el valor
      this.registros[payload.fila][this.selection[payload.columna - 1].cod] =
        payload.data;
      if (this.columna === this.selcolumn.columnValor) {
        this.calculaTotales();
      }
    },
    deleteReg(payload) {
      this.registros.splice(payload, 1);
      this.fila = payload - 1;
    },
    showInput(f) {
      if (this.fila === f) {
        return true;
      } else {
        return false;
      }
    },
    changeColumna(n) {
      this.columna = n;
    },
    determinaColumna(_this) {
      _this.selection.forEach(function (k, v) {
        if (k.cod === "valor") {
          _this.selcolumn.columnValor = v + 1;
        }
        if (k.cod === "base") {
          _this.selcolumn.columnBase = v + 1;
        }
        if (k.cod === "ccostos") {
          _this.selcolumn.columnccostos = v + 1;
        }
        if (k.cod === "docRef") {
          _this.selcolumn.columndocRef = v + 1;
        }
        if (k.cod === "ccostos") {
          _this.selcolumn.columnccostos = v + 1;
        }
        if (k.cod === "descripcion") {
          _this.selcolumn.columndescripcion = v + 1;
        }
        if (k.cod === "nit") {
          _this.selcolumn.columnnit = v + 1;
        }
        if (k.cod === "cuenta") {
          _this.selcolumn.columncuenta = v + 1;
        }
        if (k.cod === "tipo") {
          _this.selcolumn.columntipo = v + 1;
        }
        if (k.cod === "nproducto") {
          _this.selcolumn.columnproducto = v + 1;
        }
        if (k.cod === "cantidad") {
          _this.selcolumn.columncantidad = v + 1;
        }
        if (k.cod === "vlrUnitario") {
          _this.selcolumn.columnpunitario = v + 1;
        }
        if (k.cod === "nbodega") {
          _this.selcolumn.columnbodega = v + 1;
        }
        if (k.cod === "batchcodigo") {
          _this.selcolumn.columncodbatch = v + 1;
        }
        if (k.cod === "batchnombre") {
          _this.selcolumn.columnnombatch = v + 1;
        }
      });
    },
    createreg(_this, isSplice) {
      const d = {
        // estos son los campos del batch
        batchcodigo: null,
        batchnombre: null,
        // aqui terminan los campos del batch
        idcuenta: null,
        idnit: null,
        descripcion: null,
        fecha: null,
        documento: null, // aqui va el numero de documento que tiene la comundata
        comprobanteid: null, // aqui va el id del comprobante que lo tiene la coumndata
        docRef: 0,
        ccostos: 0,
        base: 0,
        tipo: null, // 1 para el debito y 2 para el credito
        valor: 0,
        year: null, // aqui va el año que viene de comundata
        mes: null, // aqui va el mes que viene de commundata
        // datosFactura: false, // este es para la factura
        turno: null, // este es para el id del turno en el caso que sea de un cuadre de caja
        tipor: null, // este es tipo de registro ingreso inventario costo o impuesto y solo aplica para punto de venta
        producto: null, // este es el id del producto para productos de punto de venta
        grupop: null, // este es el id del grupo del producto
        pventa: false, // este se pone true si es de punto de venta
        bodega: null, // este es el id de la bodega
        cantidad: 0, // numero de cantidades
        vlrUnitario: 0, // numero del valor unitario
        esTotal: false, // true o false para saber si es el total del documento
        descuento: null, // descuento este dato solo lo tiene las cuentas de ventas de la factura
        orden: null,
        // hasta aca es la estructura de la base de datos
        cuenta: null,
        cuentadetalle: null,
        nombreCuenta: null,
        nit: null,
        nombreNit: null,
        nombreCcostos: null,
        idCcostos: null,
        pptal: null,
        idpptal: null,
        nombrebodega: null,
        nbodega: null,
        nombreproducto: null,
        nproducto: null,
        productodetalle: null,
        porcentaje: null, // aqui va el porcentaje de retefuente
        tCuenta: true,
        tNit: false,
        tDescripcion: true,
        tCcosto: false,
        tBase: false,
        tDocref: false,
        tProducto: false,
        tCantidad: false,
        tPreciounitario: false,
        tBodega: false,
        tBatchcodigo: false,
        tBatchnombre: false,
        tTipo: true,
        tValor: true,
        tDescuento: true,
        cumpleCuenta: true,
        cumpleNit: true,
        cumpleDescripcion: true,
        cumpleRef: true,
        cumpleCcosto: true,
        cumpleBase: true,
        cumpleProducto: true,
        cumpleCantidad: true,
        cumplePreciounitario: true,
        cumpleBodega: true,
        cumpleValor: true,
        cumpleTipo: true,
        cumpleDescuento: true,
        cumpleBatchcodigo: true,
        cumpleBatchnombre: true,
        cumpleTodo: false,
      };
      if (isSplice) {
        _this.registros.splice(_this.registros.length - 1, 0, d);
      } else {
        _this.registros.push(d);
      }
    },
    async traeBodegas(_this) {
      let result;
      try {
        result = await apiServices.get(`/bodegas`);
        _this.$store.commit("refreshBodegas", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las bodegas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando las bodegas", err);
      }
    },
    async traeProductos(_this) {
      let result;
      try {
        result = await apiServices.get(`/productos`);
        _this.$store.commit("refreshProductos", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los productos.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los productos", err);
      }
    },
    async traeNits(_this) {
      let result;
      try {
        result = await apiServices.get(`/nits`);
        _this.$store.commit("refreshNits", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los terceros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los terceros", err);
      }
    },
    async traeCuentas(_this) {
      let result;
      try {
        result = await apiServices.get(`/cuentas/reg`);
        _this.$store.commit("refreshCuentas", result.data);
        this.cuentasModal = [];
        result.data.forEach((el) => {
          const d = {};
          d.codigo = el.codigo;
          d.nombre = el.nombre;
          d.id = el._id;
          d.selected = false;
          _this.cuentasModal.push(d);
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las cuentas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando las cuentas", err);
      }
    },
    async traeCCostos() {
      const _this = this;
      let result;
      try {
        result = await apiServices.get(`/ccostos`);
        _this.comundata.ccostos = result.data;
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los centros de costos.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los centros de costos", err);
      }
    },
    eliminarborrador() {
      localStorage.removeItem("temporalcontador");
      this.borrador = null;
      this.existborrador = false;
    },
    cargarborrador() {
      this.textInputs.c1 = this.borrador.comprobante.codigo;
      this.textInputs.c2 = this.borrador.comprobante.consecutivoc;
      this.textInputs.c3 = this.borrador.dia;
      this.blurFunction("c1");
      this.blurFunction("c2");
      this.blurFunction("c3");
      this.existborrador = false;
      setTimeout(function () {
        // aqui debe ir el input donde debe ir cuando cargue el borrador
        document.getElementById("inputReg").focus();
      }, 5);
    },
    async traeComprobantes() {
      const _this = this;
      let result;
      try {
        result = await apiServices.get(`/comprobantescontador`);
        this.comprobanteModal = [];
        this.comprobantes = result.data;
        result.data.forEach((el) => {
          const d = {};
          d.codigo = el.codigo;
          d.nombre = el.nombre;
          d.id = el._id;
          d.selected = false;
          _this.comprobanteModal.push(d);
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    keyfunction(e, id) {
      if (e.keyCode === 113) {
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (id === "c1") {
        if (e.keyCode === 13) {
          e.preventDefault();
          document.getElementById("c2").focus();
        }
        if (e.keyCode === 39) {
          if (!this.editsel) {
            e.preventDefault();
            document.getElementById("c2").focus();
          }
        }
        if (e.keyCode === 114) {
          e.preventDefault();
          this.launchModal();
        }
      }
      if (id === "c2") {
        if (e.keyCode === 13) {
          e.preventDefault();
          document.getElementById("c3").focus();
        }
        if (e.keyCode === 39) {
          if (!this.editsel) {
            e.preventDefault();
            document.getElementById("c3").focus();
          }
        }
      }
      if (id === "c3") {
        if (e.keyCode === 37) {
          e.preventDefault();
          document.getElementById("c1").focus();
        }
        if (e.keyCode === 13) {
          e.preventDefault();
          if (this.comundata.comprobante) {
            // aqui se debe poner el input al que debe ir para hacer el registro contable
            document.getElementById("inputReg").focus();
          } else {
            document.getElementById("c1").focus();
          }
        }
      }
    },
    blurFunction(el) {
      let text = this.textInputs[el];
      if (el === "c1") {
        const indice = text.indexOf(" - ");
        if (text.indexOf(" - ") !== -1) {
          text = text.substr(0, indice);
        }
        const comprobante = functions.findData(
          this.comprobantes,
          text,
          "codigo"
        );
        if (comprobante) {
          this.comundata.periodo = this.empresa.mes;
          this.textInputs[el] = `${comprobante.codigo} - ${comprobante.nombre}`;
          this.textInputs["c2"] = `${comprobante.consecutivoc}`;
          this.comundata.comprobante = comprobante;
          this.determinaColumna(this);
          if (this.borrador) {
            this.registros = this.borrador.registros;
          } else {
            if (this.registros.length === 0) {
              this.createreg(this, false);
            }
            this.fila = 0;
          }
        } else {
          if (text === "") {
            this.comundata.comprobante = null;
          } else {
            this.comundata.comprobante = null;
            this.textInputs[el] = "";
            this.$store.dispatch("notify", {
              message: "El comprobante no existe.",
              type: "is-warning",
              position: "top-center",
            });
          }
        }
      }
      if (el === "c2") {
        this.findDocumento();
        // aqui debe ir y buscar los registros en caso que el documento exista y debe cargarlo
      }
      if (el === "c3") {
        text = parseInt(text);
        if (isNaN(text)) {
          text = 1;
        } else {
          if (text > 31 || text < 1) {
            text = 1;
          }
        }
        this.textInputs["c3"] = text;
        this.comundata.dia = text;
      }
    },
    async findDocumento() {
      try {
        const _this = this;
        const documentoId = this.comundata.comprobante._id;
        const doc = this.textInputs.c2;
        const periodo = this.comundata.periodo;
        const result = await apiServices.get(
          `/mdocumento/${documentoId}/${doc}/${periodo}`
        );
        if (result.data) {
          if (result.data.length > 0) {
            this.registros = [];
            for (let index in result.data) {
              _this.createreg(_this, false);
              _this.poblarregistros(index, result.data[index]);
              _this.validaRenglon(index);
            }
            _this.registros = functions.order1(_this.registros, "orden");
            _this.calculaTotales();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    poblarregistros(fila, dato) {
      let formatdate = new Date(dato.fecha);
      let dia = formatdate.getDate();
      this.textInputs.c3 = dia;
      this.registros[fila].batchcodigo = dato.batchcodigo
        ? dato.batchcodigo
        : null;
      this.registros[fila].batchnombre = dato.batchnombre
        ? dato.batchnombre
        : null;
      this.registros[fila].idcuenta = dato.idcuenta ? dato.idcuenta._id : null;
      this.registros[fila].idnit = dato.idnit ? dato.idnit._id : null;
      this.registros[fila].descripcion = dato.descripcion
        ? dato.descripcion
        : null;
      this.registros[fila].fecha = dato.fecha ? dato.fecha : null;
      this.registros[fila].documento = dato.documento ? dato.documento : null;
      this.registros[fila].comprobanteid = dato.comprobanteid
        ? dato.comprobanteid
        : null;
      this.registros[fila].docRef = dato.docRef ? dato.docRef : 0;
      this.registros[fila].ccostos = dato.ccostos ? dato.ccostos : 0;
      this.registros[fila].base = dato.base ? dato.base : 0;
      this.registros[fila].tipo = dato.tipo ? dato.tipo : null;
      this.registros[fila].valor = dato.valor ? dato.valor : 0;
      this.registros[fila].year = dato.year ? dato.year : null;
      this.registros[fila].mes = dato.mes ? dato.mes : null;
      this.registros[fila].turno = dato.turno ? dato.turno : null;
      this.registros[fila].tipor = dato.tipor ? dato.tipor : null;
      this.registros[fila].producto = dato.producto ? dato.producto._id : null;
      this.registros[fila].nproducto = dato.producto
        ? dato.producto.codigo
        : null;
      this.registros[fila].nombreproducto = dato.producto
        ? dato.producto.descripcion
        : null;
      this.registros[fila].grupop = dato.grupop ? dato.grupop : null;
      this.registros[fila].pventa = dato.pventa ? dato.pventa : false;
      this.registros[fila].bodega = dato.bodega ? dato.bodega._id : null;
      this.registros[fila].nbodega = dato.bodega ? dato.bodega.codigo : null;
      this.registros[fila].nombrebodega = dato.bodega
        ? dato.bodega.descripcion
        : null;
      this.registros[fila].cantidad = dato.cantidad ? dato.cantidad : null;
      this.registros[fila].vlrUnitario = dato.vlrUnitario
        ? dato.vlrUnitario
        : null;
      this.registros[fila].esTotal = dato.esTotal ? dato.esTotal : false;
      this.registros[fila].descuento = dato.descuento ? dato.descuento : false;
      this.registros[fila].orden = dato.orden ? dato.orden : null;
      this.registros[fila].cuenta = dato.idcuenta ? dato.idcuenta.codigo : null;
      this.registros[fila].nombreCuenta = dato.idcuenta
        ? dato.idcuenta.nombre
        : null;
      this.registros[fila].cuentadetalle = dato.idcuenta ? dato.idcuenta : null;
      this.registros[fila].nit = dato.idnit ? dato.idnit.codigo : null;
      this.registros[fila].nombreNit = dato.nombreNit
        ? dato.idnit.nombre
        : null;
    },
    launchModal() {
      this.$store.commit("launchModal", {
        title: "Seleccione el Comprobante",
        oktext: "Aceptar",
        canceltext: "Cancelar",
        titleTable: [
          { cod: "codigo", name: "Código" },
          { cod: "nombre", name: "Nombre" },
        ],
        table: this.comprobanteModal,
        result: "c1",
      });
    },
    periodselected(period) {
      this.period = period;
    },
    async changeofmonth() {
      try {
        const period = {
          codigo: `${this.period.year}${
            parseInt(this.period.months[0]) < 10
              ? "0" + this.period.months[0]
              : this.period.months[0]
          }`,
        };
        const result = await apiServices.post(`/changeofmonth`, period);
        if (result.data) {
          if (result.data.message) {
            this.$store.dispatch("notify", {
              message: "El mes no existe. Debe crearlo primero",
              type: "is-danger",
              duration: 4000,
            });
            this.period.year = parseInt(this.empresa.mes.substr(0, 4));
            this.period.months = [parseInt(this.empresa.mes.substr(4, 2))];
          } else {
            const empresa = this.empresa;
            empresa.mes = period.codigo;
            this.$store.commit("refreshEmpresa", empresa);
            if (this.comundata.comprobante) {
              this.comundata.periodo = period.codigo;
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    addBatch() {
      this.selection.splice(4, 0, {
        cod: "batchcodigo",
        nombre: "Cod Lote",
        bd: "batchcodigo",
        tiene: "tBatchcodigo",
        valida: "cumpleBatchcodigo",
        texto: "batchcodigo",
      });
      this.selection.splice(5, 0, {
        cod: "batchnombre",
        nombre: "Nom Lote",
        bd: "batchnombre",
        tiene: "tBatchnombre",
        valida: "cumpleBatchnombre",
        texto: "batchnombre",
      });
    },
  },
  created() {
    const _this = this;
    if (this.empresa._id !== "no id") {
      this.period.year = parseInt(this.empresa.mes.substr(0, 4));
      this.period.months = [parseInt(this.empresa.mes.substr(4, 2))];
      if (this.empresa.lote) {
        // la empresa esta configurada para que pida lote de producto
        // se le agregan los botones de codigo lote y nombre lote
        this.addBatch();
      }
    }
    this.traeComprobantes();
    let temporal = localStorage.getItem("temporalcontador");
    temporal = JSON.parse(temporal);
    if (temporal) {
      this.existborrador = true;
      this.borrador = temporal;
    }
    if (this.cuentas.length === 0) {
      this.traeCuentas(this);
    } else {
      this.cuentasModal = [];
      this.cuentas.forEach((el) => {
        const d = {};
        d.codigo = el.codigo;
        d.nombre = el.nombre;
        d.id = el._id;
        d.selected = false;
        _this.cuentasModal.push(d);
      });
    }
    if (this.nits.length === 0) {
      this.traeNits(this);
    }
    if (this.bodegas.length === 0) {
      this.traeBodegas(this);
    }
    this.traeProductos(this);
    this.traeCCostos();
  },
  watch: {
    fila(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
      };
      localStorage.setItem("temporalcontador", JSON.stringify(temporal));
    },
    columna(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
      };
      this.calculaTotales();
      localStorage.setItem("temporalcontador", JSON.stringify(temporal));
      if (ov === this.selcolumn.columncuenta) {
        this.validaCuenta(this.fila, this);
      } else {
        if (ov === this.selcolumn.columnnit) {
          // aqui valida cuando salga del nit
          this.validaconcepto(this.fila, ov, this);
          if (
            !this.registros[this.fila].cumpleNit &&
            this.registros[this.fila].nit !== null
          ) {
            this.$store.commit("launchModalnit", this.registros[this.fila].nit);
            this.columna = this.selcolumn.columnnit;
          }
        } else {
          if (
            nv === this.selcolumn.columncuenta &&
            ov === this.selcolumn.columnValor
          ) {
          } else {
            this.validaconcepto(this.fila, ov, this);
          }
        }
      }
    },
    resultDatamodal(newv, oldv) {
      if (newv.result) {
        if (newv.result.substr(0, 1) === "c") {
          // esto es si el resultado del modal es el encabezado del registro ejecute algo
          if (newv.result.substr(1, 1) === "1") {
            this.textInputs.c1 = newv.data[newv.title[0].cod];
            document.getElementById(newv.result).focus();
          }
        }
      }
    },
    empresa(nv, ov) {
      if (nv._id !== "no id" && nv._id !== ov._id) {
        this.period.year = parseInt(this.empresa.mes.substr(0, 4));
        this.period.months = [parseInt(this.empresa.mes.substr(4, 2))];
        if (nv.lote) {
          // la empresa esta configurada para que pida lote de producto
          // se le agregan los botones de codigo lote y nombre lote
          this.addBatch();
        }
      }
    },
    period(nv, ov) {
      if (nv) {
        this.changeofmonth();
        // Aqui ejecuto algo si cambia de periodo
      }
    },
  },
  components: {
    yPeriodselector,
    yFormregistro,
    yViewregistro,
  },
};
</script>

<style lang="scss" scoped>
.notification {
  padding: 15px;
  margin-bottom: 15px;
}
.selected {
  box-shadow: 0px 3px 6px #c9c9c9;
}
.bordebutton {
  border-bottom: 1px solid #e6e6e6;
  padding-left: 12px;
}
.numero {
  font-size: 14px;
  padding: 3px 7px 3px 7px;
  width: 27px;
  border-radius: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/registrarcontador/Registrarcontador.vue